// extracted by mini-css-extract-plugin
export default {"svg":"TradeHistoryButton_svg__SZMW3","div":"TradeHistoryButton_div__nRfcM"};